/**
 * Truncate
 */

(function ($) {
  var identifier = {
    container: '[data-truncate]',
    cropped: '[data-truncate-cropped]',
    expanded: '[data-truncate-expanded]',
    toggle: '[data-truncate-toggle]',
    data: {
      labelShow: 'truncate-label-show',
      labelHide: 'truncate-label-hide'
    }
  };

  var $faqElements = $(identifier.container);

  if ($faqElements.length > 0) {
    $faqElements.each(function() {
      var $element = $(this),
          $cropped = $element.find(identifier.cropped),
          $expanded = $element.find(identifier.expanded),
          $toggle = $element.find(identifier.toggle),

          showExpandedOnly = function() {
            $toggle.hide();
            $cropped.hide();
            $expanded.show();
          },

          showExpanded = function() {
            $toggle.text($element.data(identifier.data.labelHide));
            $cropped.hide();
            $expanded.show();
          },

          showCropped = function() {
            $toggle.text($element.data(identifier.data.labelShow));
            $cropped.show();
            $expanded.hide();
          };

      $toggle.on("click", function (e) {
        e.preventDefault();

        if($expanded.is(":visible")) {
          showCropped();
        } else {
          showExpanded();
        }
      });

      if($cropped.html().length < $expanded.html().length) {
        showCropped();
      } else {
        showExpandedOnly();
      }
    });
  }
})(jQuery);
